import { useAdviseursGetAdviseurById } from '@services/crm-public/orval-api/adviseurs-api/adviseurs-api';
import type { MaybeRefOrGetter } from 'vue';
import { useRouteAdviseurnummer } from './routeAdviseurnummer';

export function useAdviseur(options?: {
  enabled?: MaybeRefOrGetter<boolean | undefined>;
  staleTime?: MaybeRefOrGetter<number>;
}) {
  const { adviseurnummer } = useRouteAdviseurnummer();

  return useAdviseursGetAdviseurById(adviseurnummer, {
    query: {
      ...options,
      select: ({ result }) => result,
    },
  });
}
